import { ReportTranslationKeys } from 'intl/keys';
import { TranslationKey } from 'intl/types/translationKey';
import { AttachmentsScope } from 'shared/domain/report/types/model/common';

const ATTACHMENTS_SCOPE_LABEL_KEYS: Record<AttachmentsScope, TranslationKey> = {
  [AttachmentsScope.all]: ReportTranslationKeys.attachmentsScopeAll,
  [AttachmentsScope.main]: ReportTranslationKeys.attachmentsScopeMain,
};

export function attachmentsScopeLabelKey(
  scope: AttachmentsScope
): TranslationKey {
  return ATTACHMENTS_SCOPE_LABEL_KEYS[scope];
}
